<template>

  <nav class="api-nav" :style="{
    'height': $screen.breakpoint != 'sm' ? '100%' : '50px'
    }">
    <ul v-if="$screen.breakpoint != 'sm'">
      <li v-for="(sec, index) in sections" :class="`api-nav-sec${getActiveIndex() == index ? ' ans-active' : ''}`" @click="$store.dispatch('updateAPISection', index)">
        <div class="api-nav-sec-head">
          <img :src="getLocalImg(sec.img)" class="api-nav-icon">
          <h3>{{sec.title}}</h3>
        </div>
        <ul class="api-nav-sublist" v-if="sec.title !== 'Examples'">
          <li v-for="(sub, subIndex) in sec.subsections" class="api-nav-sublist-item">
            <h4>{{sub.title}}</h4>
          </li>
        </ul>
        <div class="sec-marker" v-if="index == getActiveIndex()"></div>
      </li>
    </ul>
    <div v-else class="hor-api-nav">
      <div v-for="(sec, index) in sections" @click="$store.dispatch('updateAPISection', index)">
        <img :src="getLocalImg(sec.img)" class="api-nav-icon">
      </div>
    </div>
  </nav>

</template>

<script type="text/javascript">

export default {
  data(){
    return {
    }
  },
  computed: {
    sections: function(){
      return this.$store.getters.getAPISections();
    }
  },
  props: ['active'],
  methods: {
    getLocalImg(img){
      return require(`@/assets/${img}.png`);
    },
    getActiveIndex(){
      return this.$store.getters.getActiveSection(true);
    }
  }
}

</script>

<style>

.api-nav {
  width: 450px;
  max-width: 100%;
  border-right: 2px solid rgb(0, 153, 191);
  overflow-x: hidden;
}

.api-nav ul {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-left: 25px;
  overflow-x: hidden;
}

.hor-api-nav {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.hor-api-nav div {
  width: 19%;
  height: 41px;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgb(0, 153, 191);
  margin-bottom: 4px;
  border-bottom: 1px solid rgb(0, 153, 191);
}

.api-nav-sec {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  list-style: none;
  cursor: pointer;
  position: relative;
  padding: 1px 0px 1px 0px;
  max-height: 20%;
  min-height: 120px;
  margin-bottom: 6px;
}

.ans-active {
  background: rgb(77, 102, 129);
  color: white;
  width: 100%;
  padding-left: 20px;
}

.api-nav-sec-head {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
}

.api-nav-sec h3 {
  font-weight: 400;
  color: rgb(0, 153, 191);
  width: 75%;
  cusror: pointer;
}

.api-nav-icon {
  margin-right: 10px;
  height: 24px;
}

.api-nav-sublist {
  width: 100%;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0px;
  padding: 0px;
}

.api-nav-sublist-item {
  height: 25px;
  margin: 2px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  list-style: none;
  width: 79%;
  text-align: left;
}

.api-nav-sublist-item h4 {
  font-weight: 400;
  padding: 1px;
  margin: 2px;
}

.sec-marker {
  width: 30px;
  height: 30px;
  background: rgb(0, 153, 191);
  position: absolute;
  top: calc(50% - 15px);
  right: 0px;
  border-top-left-radius: 100%;
  border-bottom-left-radius: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/api/Nav.vue